import React from "react";
import './App.css';
import { Switch, Route } from "react-router-dom";
import Navbar from "./Components/Header/Navbar";
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Gallery from "./Components/Gallery/Gallery";
import Team from "./Components/Team/Team";
import Blog from "./Components/Blog/Blog";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import GalleryVideos from "./Components/Gallery/GalleryVideos";
import AdminGallery from "./Components/Admin/AdminGallery";

function App() {
  return (
    <div className="w-full">
      <Navbar />
      <div className="pt-28">
        <Switch>
          <Route exact path='/' component={Home} />
          <Route path='/about' component={About} />
          <Route path='/gallery' component={Gallery} />
          <Route path='/videos' component={GalleryVideos} />
          <Route path='/team' component={Team} />
          <Route path='/blog' component={Blog} />
          <Route path='/contact' component={Contact} />
          <Route path='/admin' component={AdminGallery} />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

export default App;
